import React from 'react';

import Icon, { ICON_TYPES, ICONS } from '@/src/components/common/Elements/Icon/Icon';
import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { useHover } from '@/src/hooks/useHover';
import { cn } from '@/src/util/ui';

type StatusInfoButtonProps = {
  className: string;
  iconType: (typeof ICON_TYPES)[keyof typeof ICON_TYPES];
  tooltipPosition: 'bottom' | 'right';
  tooltipWidth: string;
};

const StatusInfoButton = ({
  className,
  iconType = ICON_TYPES.outlined,
  tooltipPosition = 'bottom',
  tooltipWidth = '!tw-w-[328px] !tw-max-w-[328px]',
}: StatusInfoButtonProps) => {
  const [hoverRef, isHovered] = useHover();
  // Force a fixed iconType when hovered
  const myIconType = isHovered ? ICON_TYPES.filled : iconType;

  return (
    <React.Fragment>
      <Icon
        className={cn('tw-text-[16px]', 'tw-ml-[2px]', 'hover:tw-text-cfo-blue-600', className)}
        icon={ICONS.info}
        data-tooltip-id={'sib-tooltip'}
        iconType={myIconType}
        iconRef={hoverRef}
      />
      <Tooltip
        id={'sib-tooltip'}
        place={tooltipPosition}
        effect="solid"
        className={cn('tw-normal-case', tooltipWidth)}
      >
        Inactive account and their data will be permanently and automatically deleted after (1) one
        year.
      </Tooltip>
    </React.Fragment>
  );
};

export default StatusInfoButton;
